import React, { useEffect, useState } from "react";
import logoVgaurd from "../../assets/images/vguardLogoImg.svg";
import downarrow from "../../assets/images/downArrow.svg";
import topbarprofileimg from "../../assets/images/Icons/profileTopbar.svg";
import Home from "../../assets/images/home.svg";
import Vistormaping from "../../assets/images/visitorsMapping.svg";
import Status from "../../assets/images/status.svg";
import Reports from "../../assets/images/reports.svg";
import Empmaster from "../../assets/images/employeMaster.svg";
import Settings from "../../assets/images/Icons/setting.svg";
import Ert from "../../assets/images/Icons/ert.svg";
import safeAssemble from "../../assets/images/Icons/assembly.svg";
import HeaderitemComponent from "../../constants/contentFile.json";
import Profile from "../../assets/images/profile.svg";
import Logout from "../../assets/images/logout.svg";
import Linehorizontal from "../../assets/images/lineHorizontal.svg";
import Polygon from "../../assets/images/polygon.svg";
import Contacts from "../../assets/images/contacts.svg";
import "./topbar.css";
import { baseURL } from "../../api/Axios";
import PropTypes from "prop-types";
import { Container, Nav, Navbar } from "react-bootstrap";
import { Link, Route, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import RouteContents from "../../constants/routesContent.json";

const permitted = localStorage.getItem("permissions");
const permittedTabs = permitted && JSON.parse(permitted);
const permittedIDs =
  permittedTabs &&
  permittedTabs.map((item) => {
    return item.Feature;
  });

const TopBar = ({ onClick, userloginName }) => {
  const [showdropMenuList, setShowDropMenuList] = useState(false);
  const navPath = window.location.pathname;
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (
      localStorage.getItem("previousPath") === "/home" &&
      window.location.pathname != "/home"
    ) {
      localStorage.setItem("previousPath", window.location.pathname);
      navigate(0);
    }
  });
 const isSuperAdmin = localStorage.getItem("is_SuperAdmin");

  const logout = () => {
    localStorage.removeItem("x-access-token");
    localStorage.removeItem("permissions");
    localStorage.removeItem("remember");
    navigate(RouteContents.LOGIN);
  };
  var profileNameData = JSON.parse(localStorage.getItem("profileDataSharing"));
  const headerConstants = HeaderitemComponent.headerComponent;
  const imgPath = profileNameData?.Image
    ? `${baseURL}/images/${profileNameData?.Image}`
    : topbarprofileimg;
  return (
    <Container className="mainConiterTopBar">
      <div className="navMainbar">
        <div className="d-flex flex-row bd-highlight align-items-center">
          <div>
            <img
              src={logoVgaurd}
              onClick={() => navigate(RouteContents.HOMEPAGE)}
            />
          </div>
          <div className="lineStyle"></div>
          <div className="textHeadCount">{headerConstants.headCountSystem}</div>
        </div>

        <div className="user-section d-flex flex-row-reverse bd-highlight">
          <div
            className="downArrowContainerTopBar"
            onClick={() => {
              setShowDropMenuList(!showdropMenuList);
            }}
          >
            <img className="downArrowImg" src={downarrow} />
          </div>

          <div className="profileImageCircle">
            <img className="profileImg" src={imgPath} />
          </div>

          <div className="userNametxt">{profileNameData?.name}</div>
        </div>
      </div>

      <div className="topbar-links">
        <Navbar>
          <Nav className="navBarContainer">
            <Link
              to={RouteContents.HOMEPAGE}
              className={
                navPath === RouteContents.HOMEPAGE
                  ? "activeImg"
                  : "navIconsStyle"
              }
            >
              <img src={Home} alt="home" />

              <span
                className={
                  navPath === RouteContents.HOMEPAGE ? "activeText" : "navText"
                }
              >
                {headerConstants.home}
              </span>
            </Link>
            <Link
              to={RouteContents.VISITORS_MAPPING}
              className={
                navPath === RouteContents.VISITORS_MAPPING
                  ? "activeImg"
                  : navPath === RouteContents.VISITORS_DETAILS
                  ? "activeImg"
                  : navPath === RouteContents.GUEST_REGISTER
                  ? "activeImg"
                  : "navIconsStyle"
              }
            >
              <img src={Vistormaping} alt="vistorsmapping" />
              <span
                className={
                  navPath === RouteContents.VISITORS_MAPPING
                    ? "activeText"
                    : navPath === RouteContents.VISITORS_DETAILS
                    ? "activeText"
                    : navPath === RouteContents.GUEST_REGISTER
                    ? "activeText"
                    : "navText"
                }
              >
                {headerConstants.vistorsmapping}
              </span>
            </Link>
            <Link
              to={RouteContents.STATUS}
              className={
                navPath === RouteContents.STATUS
                  ? "activeImg"
                  : navPath === RouteContents.STATUSZONE
                  ? "activeImg"
                  : navPath === RouteContents.STATUS_CATEGORY
                  ? "activeImg"
                  : navPath === RouteContents.STATUS_EMPLOYEE
                  ? "activeImg"
                  : navPath === RouteContents.STATUS_ERT
                  ? "activeImg"
                  : navPath === RouteContents.STATUS_ERT_DETAILS
                  ? "activeImg"
                  : navPath === RouteContents.STATUS_ALL
                  ? "activeImg"
                  : "navIconsStyle"
              }
            >
              <img src={Status} alt="status" />
              <span
                className={
                  navPath === RouteContents.STATUS
                    ? "activeText"
                    : navPath == RouteContents.STATUSZONE
                    ? "activeText"
                    : navPath == RouteContents.STATUS_CATEGORY
                    ? "activeText"
                    : navPath == RouteContents.STATUS_EMPLOYEE
                    ? "activeText"
                    : navPath === RouteContents.STATUS_ERT
                    ? "activeText"
                    : navPath === RouteContents.STATUS_ERT_DETAILS
                    ? "activeText"
                    : navPath === RouteContents.STATUS_ALL
                    ? "activeText"
                    : "navText"
                }
              >
                {headerConstants.status}
              </span>
            </Link>
            <Link
              to={RouteContents.REPORT}
              className={
                navPath === RouteContents.REPORT
                  ? "activeImg"
                  : navPath === RouteContents.REPORT_ZONE
                  ? "activeImg"
                  : navPath === RouteContents.VEHICLE_DETAILS
                  ? "activeImg"
                  : "navIconsStyle"
              }
            >
              <img src={Reports} alt="reports" />
              <span
                className={
                  navPath === RouteContents.REPORT
                    ? "activeText"
                    : navPath === RouteContents.REPORT_ZONE
                    ? "activeText"
                    : navPath === RouteContents.VEHICLE_DETAILS
                    ? "activeText"
                    : "navText"
                }
              >
                {headerConstants.report}
              </span>
            </Link>
            <Link
              to={RouteContents.EMPLOYEE_MASTER}
              className={
                navPath === RouteContents.EMPLOYEE_MASTER
                  ? "activeImg"
                  : navPath === RouteContents.EMPLOYEE_DETAILS
                  ? "activeImg"
                  : navPath === RouteContents.EMPLOYEE_REGISTRATION
                  ? "activeImg"
                  : "navIconsStyle"
              }
            >
              <img src={Empmaster} alt="employeemaster" />
              <span
                className={
                  navPath === RouteContents.EMPLOYEE_MASTER
                    ? "activeText"
                    : navPath === RouteContents.EMPLOYEE_DETAILS
                    ? "activeText"
                    : navPath === RouteContents.EMPLOYEE_REGISTRATION
                    ? "activeText"
                    : "navText"
                }
              >
                {headerConstants.employemaster}
              </span>
            </Link>
            {isSuperAdmin === "Super Admin" ?
            <Link
              to={RouteContents.SETTINGS_PERMISSION}
              className={
                navPath === RouteContents.SETTINGS
                  ? "activeImg"
                  : navPath === RouteContents.ADD_DEVICE
                  ? "activeImg"
                  : navPath === RouteContents.SETTINGS_PERMISSION
                  ? "activeImg"
                  : navPath === RouteContents.SETTINGS_ROLE_MANAGEMENT
                  ? "activeImg"
                  : navPath === RouteContents.SETTINGS_ROLE
                  ? "activeImg"
                  : navPath === RouteContents.ROLE_ASSIGN
                  ? "activeImg"
                  : "navIconsStyle"
              }
            >
              <img src={Settings} alt="settings" />
              <span
                className={
                  navPath == RouteContents.SETTINGS
                    ? "activeText"
                    : navPath === RouteContents.ADD_DEVICE
                    ? "activeText"
                    : navPath === RouteContents.SETTINGS_PERMISSION
                    ? "activeText"
                    : navPath === RouteContents.SETTINGS_ROLE_MANAGEMENT
                    ? "activeText"
                    : navPath === RouteContents.SETTINGS_ROLE
                    ? "activeText"
                    : navPath === RouteContents.ROLE_ASSIGN
                    ? "activeText"
                    : "navText"
                }
              >
                {headerConstants.settings}
              </span>
            </Link>
            :""}
            <Link
              to={RouteContents.EVACUATION}
              className={
                navPath === RouteContents.EVACUATION && location?.state === null
                  ? "activeImg"
                  : navPath === RouteContents.ERT_DETAILS
                  ? "activeImg"
                  : "navIconsStyle"
              }
            >
              <img src={Ert} alt="Ert" />
              <span
                className={
                  navPath === RouteContents.EVACUATION &&
                  location?.state === null
                    ? "activeText"
                    : navPath === RouteContents.ERT_DETAILS
                    ? "activeText"
                    : "navText"
                }
              >
                {headerConstants.ert}
              </span>
            </Link>
            <Link
              to={RouteContents.SAFE_ASSEMBLE_POINT}
              className={
                navPath === RouteContents.SAFE_ASSEMBLE_POINT
                  ? "activeImg"
                  : "navIconsStyle"
              }
            >
              <img src={safeAssemble} alt="Safeassemblepoint" />
              <span
                className={
                  navPath === RouteContents.SAFE_ASSEMBLE_POINT
                    ? "activeText"
                    : "navText"
                }
              >
                {headerConstants.safeassemblepoint}
              </span>
            </Link>
            <Link
              to={RouteContents.CONTACTS}
              className={
                navPath === RouteContents.CONTACTS
                  ? "activeImg"
                  : "navIconsStyle"
              }
            >
              <img src={Contacts} alt="Safeassemblepoint" />
              <span
                className={
                  navPath === RouteContents.CONTACTS ? "activeText" : "navText"
                }
              >
                {headerConstants.contacts}
              </span>
            </Link>
          </Nav>
        </Navbar>
      </div>
      {showdropMenuList == true ? (
        <div>
          <img src={Polygon} alt="polygon" className="imgPolygon" />

          <div className="dropdownContent">
            <div className="dropDownItem">
              <div className="dropDownItemList">
                <Link
                  to={RouteContents.PROFILE_DETAILS_EMP}
                  className={
                    navPath === RouteContents.PROFILE_DETAILS_EMP
                      ? "activeImg"
                      : "navIconsStyle"
                  }
                >
                  <img src={Profile} className="iconProfile" />

                  <span
                    className={
                      navPath === RouteContents.PROFILE_DETAILS_EMP
                        ? "porofileText"
                        : "profilenavText"
                    }
                  >
                    {headerConstants.profile}
                  </span>
                </Link>
                {/* <img src={Profile} className="imgProfile" />
                <a href={RouteContents.PROFILE_DETAILS_EMP}>Profile</a> */}
              </div>
              <div className="dropDownItemList">
                <img src={Linehorizontal} />
              </div>
              <div className="dropDownItemList">
                <img className="imgProfile" src={Logout} alt="logout" />
                <a href="" onClick={() => logout()}>
                  Logout
                </a>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </Container>
  );
};
TopBar.propTypes = {
  onClick: PropTypes.func,
  userloginName: PropTypes.string,
};
export default TopBar;
export { permittedIDs };
